import SurveyQuestionTextInput from '../text-input'
import s from '../styles.module.css'
import { useRef } from 'react'

export default function InsuranceMembershipId({
  question,
  options,
  response,
  respond,
  setOnChangeResponse,
  inputClassName,
  coachProfileVariant,
}) {
  const initialLoad = useRef(true)
  const { placeholder } = question
  const value = response && response.responseValue
  const preChecked =
    response && response.metadata && response.metadata.skipMembershipId

  const onBlur = responseValue => {
    if (initialLoad.current) {
      initialLoad.current = false
      return
    }
    respond({ responseValue, metadata: { skipMembershipId: false } })
  }

  const handleOnChangeDetailed = params => {
    setOnChangeResponse({ ...params, questionId: question.id })
  }

  const onChange = (surveyQuestionResponseId, checked) => {
    respond({
      responseValue: checked ? null : value,
      metadata: { skipMembershipId: checked },
    })
  }

  return (
    <>
      <SurveyQuestionTextInput
        value={value}
        onBlur={onBlur}
        placeholder={placeholder}
        isV2={true}
        onChangeDetailed={handleOnChangeDetailed}
        inputClassName={inputClassName}
        isRequired={question.isRequired}
        coachProfileVariant={coachProfileVariant}
      />
      {options &&
        options.length > 0 &&
        options.map(option => (
          <div key={option.value} className={s.checkboxContainer}>
            <label className={s.checkboxLabel}>
              <input
                type="checkbox"
                className={s.checkbox}
                checked={preChecked}
                onChange={e => onChange(option.value, e.target.checked)}
              />
              <span className={s.checkboxText}>{option.label}</span>
            </label>
          </div>
        ))}
    </>
  )
}
